import React, { useEffect, useCallback, useState} from 'react';
import {useToggledWaveform} from 'components/v2/toggleWaveform.js';
import {TRACK_RECORD_ARM_BUTTON} from 'constants/contextual-help.js';
import Documented from 'components/help/Documented.js';
import TrackThumbnail from '../TrackThumbnail.js';
import {connect} from 'react-redux';
import {
    setCirklonParameterSelected,
    setShowTrackEffects,
    setShowPianoRoll,
    setArrangementBottomMode,
} from 'actions/index.js';

const TrackOverview = ({
    track,
    isEnabled,
    isFrozen,
    isSelectedTrack,
    setArrangementBottomMode,
    setShowPianoRoll,
    setShowEffects,
    showName,
    setShowParams,
    mode,
}) => { 
    let className = "track-overview";
    if (isSelectedTrack) {
        className += " selected";
    }

    const {toggleWaveform} = useToggledWaveform({
        track,
        isSelectedTrack,
        sequencerEngine: track.sequencerEngine,
        setArrangementBottomMode,
        setShowPianoRoll,
        mode
    });

    const onMouseOver = useCallback(() => {
        if (track.sequencerEngine.state.keyboard.isMouseDown) {
            track.toggleEnabled();
        }
    }, [track]);

    return (
        <div className={className}>
          <div className="track-number">
            {track.trackNumber + 1}
          </div>
          <TrackThumbnail
            showPresetName={showName}
            onClickThumbnail={() => {
                setShowEffects(false);
                setShowParams(false);
                track.sequencerEngine.selectTrack(track.trackNumber);
                toggleWaveform();
            }}
            track={track}/>
        {!isFrozen ? 
         <Documented element={TRACK_RECORD_ARM_BUTTON}>
           <div
             onMouseOver={onMouseOver}
             onMouseDown={() => track.toggleEnabled()}
             className={isEnabled ? "dot enabled" : "dot"}/>
         </Documented>
         : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
    let enabledMap = state.tracks.trackIsEnabled[props.track.subSequence.id] || {};
    let isEnabled = enabledMap[props.track.trackNumber]; 
    let isSelectedTrack = state.mix.selectedTrack === props.track.trackNumber; 
    return {
        isEnabled:  isEnabled === undefined ? false : isEnabled,
        isSelectedTrack,
        isFrozen: props.track.isFrozen
    };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setShowEffects: (show) => dispatch(setShowTrackEffects(props.track.trackNumber, show)),
      setShowPianoRoll: (show) => dispatch(setShowPianoRoll(show)),
      setShowParams: param => dispatch(setCirklonParameterSelected(props.track.id, param)),
      setArrangementBottomMode: mode => dispatch(setArrangementBottomMode(mode)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackOverview);
